import { COREUI_DEVICE_ICON_MAPPING, ICON_MAPPING } from './icons'
// import * as battery0 from '@/../images/device_icons/enwitec/battery0.svg'
// import * as battery20 from '@/../images/device_icons/enwitec/battery20.svg'
// import * as battery40 from '@/../images/device_icons/enwitec/battery40.svg'
// import * as battery60 from '@/../images/device_icons/enwitec/battery60.svg'
// import * as battery80 from '@/../images/device_icons/enwitec/battery80.svg'
// import * as battery100 from '@/../images/device_icons/enwitec/battery100.svg'
// import * as chp from '@/../images/device_icons/enwitec/chp.svg'
// import * as container from '@/../images/device_icons/enwitec/container.svg'
// import * as containerAlarm from '@/../images/device_icons/enwitec/container_alarm.svg'
// import * as containerOk from '@/../images/device_icons/enwitec/container_ok.svg'
// import * as containerWarning from '@/../images/device_icons/enwitec/container_warning.svg'
import * as coreuiDeviceIcons from '@/../images/device_icons/enwitec/coreui_device_icons'
// import * as factory from '@/../images/device_icons/enwitec/factory.svg'
import * as dashboardCenterIcon from '@/../images/device_icons/enwitec/dashboard_center_icon.svg'
// import * as wallboxPlugged from '@/../images/device_icons/enwitec/wallbox_plugged.svg'
// import * as wallboxUnplugged from '@/../images/device_icons/enwitec/wallbox_unplugged.svg'
// import * as wallboxWarning from '@/../images/device_icons/enwitec/wallbox_warning.svg'
// import * as fuelcell from '@/../images/device_icons/enwitec/fuelcell.svg'
// import * as generic from '@/../images/device_icons/enwitec/generic.svg'
// import * as grid from '@/../images/device_icons/enwitec/grid.svg'
// import * as heatingelement from '@/../images/device_icons/enwitec/heatingelement.svg'
// import * as heatpump from '@/../images/device_icons/enwitec/heatpump.svg'
import * as pv from '@/../images/device_icons/enwitec/pv.svg'
// import * as rest from '@/../images/device_icons/enwitec/rest.svg'
// import * as trafo from '@/../images/device_icons/enwitec/trafo.svg'
// import * as user from '@/../images/device_icons/enwitec/user.svg'

const map = {
  // battery: battery0,
  // battery0,
  // battery20,
  // battery40,
  // battery60,
  // battery80,
  // battery100,
  // chp,
  // container,
  // containerAlarm,
  // containerOk,
  // containerWarning,
  dashboardCenterIcon,
  // factory,
  // fuelcell,
  // generic,
  // grid,
  // heatingelement,
  // heatpump,
  pv
  // rest,
  // trafo,
  // user
  // wallbox: wallboxUnplugged,
  // wallboxPlugged,
  // wallboxUnplugged,
  // wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}

export function overwriteCoreuiDeviceIcons() {
  Object.assign(COREUI_DEVICE_ICON_MAPPING, coreuiDeviceIcons)
}
